import { useEffect, useState } from "react";
import api from "@/lib/api";

// Small reusable fetcher for any public collection endpoint.
// Returns { data, loading } so callers can decide to fall back when empty.
export default function useApiCollection(endpoint) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api
      .get(endpoint)
      .then((res) => {
        if (alive) setData(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => {
        if (alive) setData([]);
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [endpoint]);

  return { data, loading };
}
